/*
 * File: /src/services/campaignServices.js
 * Created Date: Saturday June 15th 2019
 * Author: Nicolas Wegener, Roy Collins
 * -----
 * Last Modified: Thursday, 27th June 2019 4:08:11 pm
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2019 AdBase, Inc.
 */

import { authedAxios } from '../shared/axiosWrapper';
import { AD_BASE_SMSSERVICES_PATH, AD_BASE_USER_PATH, AD_BASE_SMS_PATH } from '../constants';

export default {
  /**
   * Fetch All SmsServices
   */
  fetchServices() {
    return authedAxios.get(AD_BASE_SMSSERVICES_PATH + 'message-service');
  },

  /**
   * Create a new SmsService
   */
  createService(label) {
    return authedAxios.post(AD_BASE_SMSSERVICES_PATH + 'message-service', {
      label: label
    });
  },
  /**
   * Update a SmsService
   */
  updateService(id, label) {
    return authedAxios.put(AD_BASE_SMSSERVICES_PATH + 'message-service/' + id, {
      label: label
    });
  },

  /**
   * Get Number by Number
   */
  fetchByNumber(number) {
    return authedAxios.get(AD_BASE_SMSSERVICES_PATH + 'number/' + number);
  },

  /**
   * Search for available numbers on twilio
   */
  searchNumbers(prefix) {
    return authedAxios.get(
      AD_BASE_SMSSERVICES_PATH + 'search-numbers/?prefix=' + prefix
    );
  },

  /**
   * Add number to existing message service
   *
   * @param {number} string
   * @param {service_sid} string
   */
  addNumber(phone_number, service_id) {
    return authedAxios.post(AD_BASE_SMSSERVICES_PATH + 'number', {
      message_service_id: service_id,
      phone_number: phone_number
    });
  },

  /**
   * Remove number from existing message service
   *
   * @param {number} number
   * @param {service_sid} string
   */
  removeNumber(phone_id, service_sid) {
    return authedAxios.post(
      AD_BASE_SMSSERVICES_PATH + 'message-service/' + service_sid + '/remove',
      {
        message_service_sid: service_sid,
        number_ids: [phone_id]
      }
    );
  },

  /**
   * Delete Service
   *
   * @param {number} id
   */
  deleteService(id) {
    return authedAxios.delete(AD_BASE_SMSSERVICES_PATH + 'message-service/' + id);
  },

  //////////////////////////////////////
  // BELOW IS the actual SMS functions
  // All above are twilio message service functions
  // Eventually move the above out to a twilo messages service
  //////////////////////////////////////

  /* Full paginated filter find/search
   * only does offset/limit for now but with filters
   */
  fetchSms(limit, offset, filters, unassigned, incomplete, assignee, brandIds, nameSearch, priority) {
    if (filters == undefined) {
      filters = [];
    }
    /*
    // const filters = ['direction:eq:inbound'];
    if (contactId) {
      filters.push(`contact_id:eq:${contactId}`);
    }
    */

    const params = {
      filter: filters.length ? filters : undefined,
      sort: undefined,
      limit: limit,
      offset: offset,
      unassigned: unassigned,
      incomplete: incomplete,
      assignee: assignee,
      brand_ids: brandIds,
      nameSearch: nameSearch,
      priority: priority,
    };
    /* Not build yet
    if (beforeDate) {
      params.before_date = beforeDate;
      params.before_id = beforeId;
    }
    if (afterId) {
      params.after_id = afterId;
    }
    */

    return authedAxios.get(AD_BASE_SMS_PATH, {params: params});
  },

  getSms(messageId) {
    // Gets only the base sms properties, not any extened like contact
    return authedAxios.get(AD_BASE_SMS_PATH + messageId);
  },


  /**
   * Send SMS
   *
   * @param {*} contact_id
   * @param {*} msg
   * @param {*} service_id
   * @returns
   */
  sendSms(contact_id, msg, number_id, attachments) {
    return authedAxios.post(AD_BASE_SMS_PATH + 'send/', {
      contact_id: contact_id,
      message: msg,
      from_number_id: number_id,
      attachments: attachments ? attachments : [],
    });
  },

  /**
   * Send Group SMS to many contacts
   *
   * @param {*} group_id
   * @param {*} msg
   * @param {*} number_id
   *
   * @returns
   */
  sendGroupSms(group_id, msg, number_id, attachments) {
    // Currently only send one group but can support multiple
    return authedAxios.post(AD_BASE_SMS_PATH + 'send-group/', {
      group_ids: [group_id],
      message: msg,
      from_number_id: number_id,
      attachments: attachments ? attachments : [],
    });
  },

  setLastSeen(id) {
    // THis is a one off on the user controller until we get a SMS controller
    return authedAxios.put(AD_BASE_USER_PATH + 'lastseen-sms/' + id);
  },
  assign(id, userId) {
    const payload = { user_id: userId };
    return authedAxios
      .put(AD_BASE_SMS_PATH + 'assign/' + id, payload)
      .then(r => r.data);
  },
  markCompleted(id) {
    return authedAxios
      .put(AD_BASE_SMS_PATH + 'markcompleted/' + id)
      .then(r => r.data);
  },
  markAllCompleted(contactId) {
    return authedAxios
      .put(AD_BASE_SMS_PATH + 'mark-all-completed/' + contactId)
      .then(r => r.data);
  },
  setPriority(id, priority) {
    return authedAxios
      .put(AD_BASE_SMS_PATH + 'priority/' + id,
        {priority: priority}
      )
      .then(r => r.data);
  },
};
